import styled from 'styled-components';

export const OlStyled = styled(`ol`)`
	gap: 8px;
	display: flex;
	flex-direction: column;
	margin-bottom: 16px;
	@media (max-width: 575px) {
		margin-bottom: 16px;
		font-size: 14px;
		font-weight: 400;
		line-height: 17px;
		color: #77818e;
		white-space: pre-wrap;
		padding-inline-start: 15px;
	}
`;

export const ImageStyled = styled(`img`)`
	display: block;
	margin-top: 8px;
	max-width: 70%;
	@media (max-width: 990px) {
		max-width: 100%;
	}
	max-height: 720px;
`;
